export type ThemeModePreference = 'light' | 'dark' | 'system';

export const THEME_MODE_PREFERENCES: ThemeModePreference[] = ['light', 'dark', 'system'];

// Type guard used to validate values read back from localStorage before
// trusting them as a theme preference.
function isThemeModePreference(value: unknown): value is ThemeModePreference {
  return (
    typeof value === 'string' &&
    THEME_MODE_PREFERENCES.includes(value as ThemeModePreference)
  );
}

// Namespaced localStorage key mirroring the server-side preference so the app
// can paint the correct theme synchronously on boot, before the user record
// (and its backend `appearance.theme`) has loaded.
export const THEME_MODE_STORAGE_KEY = 'tread.appearance.theme';

export function readStoredThemeMode(): ThemeModePreference | null {
  try {
    const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY);

    return isThemeModePreference(stored) ? stored : null;
  } catch {
    // localStorage can throw (private mode, disabled storage). Fail safe to the
    // system default rather than crashing the whole app on boot.
    return null;
  }
}

export function writeStoredThemeMode(mode: ThemeModePreference) {
  try {
    localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
  } catch {
    // Non-fatal — the in-memory preference still drives the current session.
  }
}
